<script setup>
definePageMeta({ layout: 'company' })

useHead({
  title: 'Refund Policy | SharkFoto',
  meta: [
    {
      name: 'description',
      content:
        'SharkFoto Refund Policy: subscription credits are refundable within 7 days of purchase (if under 50 credits used); add-on credits are non-refundable.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: 'https://sharkfoto.com/company/trust/refund-policy/',
    },
  ],
})
</script>

<template>
  <h1>Refund Policy</h1>

  <p>At SharkFoto, we strive to provide our users with the best experience possible. We understand that circumstances may change, and you might need to request a refund. Please read our refund policy carefully before making a purchase.</p>

  <h3 id="refund-eligibility">Refund Eligibility</h3>
  <ul>
    <li>
      <p><strong>Time Limit &amp; Credit Type:</strong> Refund requests are only applicable to subscription credits and must be made within <strong>7 days</strong> of your purchase. For add-on credits, we cannot process any refund requests.</p>
    </li>
    <li>
      <p><strong>Credit Usage:</strong> If you have used more than <strong>50 subscription credits</strong>, you are not eligible for a refund, regardless of the time since purchase.</p>
    </li>
  </ul>

  <h3 id="how-to-request-a-refund">How to Request a Refund</h3>
  <p>If you meet the eligibility criteria and wish to request a refund for subscription credits, please follow these steps:</p>
  <p>1. <strong>Contact Us:</strong> Reach out to our support team at <a href="mailto:support@sharkfoto.com">support@sharkfoto.com</a>.</p>
  <p>2. <strong>Provide Details:</strong> Include your account details, order number, purchase date, and reason for the refund request.</p>
  <p>3. <strong>Submit Within 7 Days:</strong> Ensure your request is submitted within 7 days of your purchase.</p>
  <p><strong>Tip:</strong> Please note that add-on credits are non-refundable.</p>

  <h3 id="processing-refunds">Processing Refunds</h3>
  <p>Once we receive your refund request, we will review it and notify you of the outcome soon. If approved, your refund will be processed to your original payment method.</p>
  <ul>
    <li>
      <p>Please note that the refund amount may be subject to a processing fee not exceeding six percent (6%) of the initial payment, and that add-on credits are not refundable</p>
    </li>
  </ul>
  <p>If you have questions about applicable fees or require further details, please contact our customer service team via <a href="mailto:support@sharkfoto.com">support@sharkfoto.com</a> for assistance.</p>

  <h3 id="changes-to-this-policy">Changes to This Policy</h3>
  <p>We reserve the right to update our refund policy at any time. Any changes will be reflected on this page, and we encourage you to review it periodically.</p>
</template>
